import  * as component  from './components'

export default [
    {
      name: 'managementreport.phishingvulnerability',
      path: '/managementreport/phishingvulnerability',
      component: component.PhishingVulnerabilityTrend,
    },
    {
      name: 'managementreport.awarenesstrendslook',
      path: '/managementreport/awarenesstrendslook',
      component: component.AwarenessTrendsLook,
    },
    {
      name: 'managementreport.reportingtrend',
      path: '/managementreport/reportingtrend',
      component: component.ReportingTrend,
    },
    {
      name: 'managementreport.weakest',
      path: '/managementreport/weakest',
      component: component.Weekest,
    },
    {
      name: 'managementreport.strongest',
      path: '/managementreport/strongest',
      component: component.Strongest,
    },
    {
      name: 'managementreport.departmentweakest',
      path: '/managementreport/departmentweakest',
      component: component.Deparmentweakest,
    },
    {
      name: 'managementreport.highrisk',
      path: '/managementreport/highrisk',
      component: component.Highrisk,
    }
]



// WEBPACK FOOTER //
// ./src/app/managementreport/routes/index.js